import { trackEvent } from "./index";

export const trackScheduleCreateInit = () => {
    trackEvent("schedule_create_init", {
    });
};